export class DecimalNumberFormatValueConverter {

    public toView(value: number): string {
        if (value == null) {
            return '0.00';
        }

        return value.toFixed(2);
    }
}
